export enum Period {
  LAST_DAY = 'day',
  LAST_WEEK = 'week',
  LAST_MONTH = 'month',
  LAST_YEAR = 'year',
}

export const PERIODS = Object.values(Period);

export enum Unit {
  SECONDS = 'SECONDS',
}

export const FormatsDict: Record<Period, string> = {
  [Period.LAST_MONTH]: 'MM.DD',
  [Period.LAST_DAY]: 'HH:mm',
  [Period.LAST_WEEK]: 'dddd',
  [Period.LAST_YEAR]: 'YYYY.MM',
};

export enum DialogChartMetric {
  TOTAL_DIALOGS = 'total_dialogs',
  TOTAL_DURATION = 'total_duration',
  VOICE_DIALOGS = 'voice_dialogs',
  TEXT_DIALOGS = 'text_dialogs',
  VOICE_DIALOGS_AVERAGE_DURATION = 'voice_dialogs_average_duration',
  // TOTAL_COST = "total_cost",
  // AVERAGE_COST = "average_cost",
}

export enum MessageChartMetric {
  TOTAL_RESPONSES = 'total_responses',
  TEXT_RESPONSES = 'text_responses',
  VOICE_RESPONSES = 'voice_responses',
}
